export default "__VITE_ASSET__DA1Xj_uU__"